import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { agency } from "../mock";
import { Button } from "./ui/button";

export default function SellBanner() {
  const go = () => document.querySelector("#estimation")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section data-testid="sell-banner" className="bg-accent text-accent-foreground">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-16 flex flex-col md:flex-row md:items-center justify-between gap-8">
        <div className="max-w-2xl">
          <h2 className="font-serif text-3xl md:text-4xl font-semibold">Vous vendez ? Parlons-en.</h2>
          <p className="mt-3 text-accent-foreground/85 text-base md:text-lg">
            Un rendez-vous suffit pour faire le point sur la valeur de votre bien et la meilleure stratégie de vente à Boulogne-Billancourt.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <Button data-testid="sell-banner-estimation-btn" onClick={go} className="h-12 px-7 rounded-full bg-[#2b2620] hover:bg-[#2b2620]/90 text-white">
            Faire estimer mon bien <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
          <a data-testid="sell-banner-phone-link" href={`tel:${agency.phoneHref}`}
            className="h-12 px-7 rounded-full border border-accent-foreground/50 inline-flex items-center justify-center gap-2 hover:bg-accent-foreground/10 transition-colors font-medium">
            <Phone className="h-4 w-4" /> {agency.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
